import { HHStack, HHTypography } from '@hinge-health/react-component-library';

interface SourceCellProps {
  source: string;
  sourceId: string;
}
export const SourceCell = ({
  source,
  sourceId,
}: SourceCellProps): JSX.Element => (
  <HHStack direction="column">
    <HHTypography hhVariant="caption">{source || '--'}</HHTypography>
    <HHTypography hhVariant="caption">{sourceId || '--'}</HHTypography>
  </HHStack>
);
